import { create } from 'zustand';

import type { FeedbackFilterType, FeedbackSortType } from '../../../types/feedbacks';

type FeedbackType = 'Comment' | 'Question' | 'Review' | 'CommentChild' | 'Answer';
export type FeedbackToReply = {
  id: string;
  type: FeedbackType;
  pageIndex: number;
  listIndex: number;
};

type FeedbackState = {
  filter: FeedbackFilterType['value'];
  sort: FeedbackSortType['apiValue'];
  isFilterOpen: boolean;
  setSort: (newSort: FeedbackSortType['apiValue']) => void;
  setFilter: (newFilter: FeedbackFilterType['value']) => void;
  setIsFilterOpen: (isOpen: boolean) => void;
};

export const useFeedbacks = create<FeedbackState>((set) => ({
  filter: 'All',
  sort: 'MostLike',
  isFilterOpen: false,
  itemToReplyId: undefined,
  setSort: (newSort: FeedbackSortType['apiValue']) => set(() => ({ sort: newSort })),
  setFilter: (newFilter: FeedbackFilterType['value']) => set(() => ({ filter: newFilter })),
  setIsFilterOpen: (isOpen: boolean) => set(() => ({ isFilterOpen: isOpen })),
}));
